function isInvalidUrlError(error: unknown): boolean {
  return error instanceof TypeError || (error instanceof Error && error.message.includes('Invalid URL'));
}

function isValidDownloadUrl(fileUrl: string): boolean {
  if (typeof URL.canParse === 'function') {
    return URL.canParse(fileUrl);
  }

  try {
    new URL(fileUrl);
    return true;
  } catch {
    return false;
  }
}

const downloadFile = (fileUrl: string, filename: string = 'data.csv') => {
  if (!fileUrl || !isValidDownloadUrl(fileUrl)) {
    throw new Error('Invalid file URL');
  }

  try {
    const parsedUrl = new URL(fileUrl);

    if (typeof document === 'undefined') {
      throw new Error('document is not defined');
    }

    const link = document.createElement('a');
    link.href = parsedUrl.toString();
    link.download = filename;

    if (parsedUrl.origin !== window.location.origin) {
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
    }

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    if (isInvalidUrlError(error)) {
      throw new Error('Invalid file URL');
    }

    if (error instanceof Error && error.message === 'document is not defined') {
      return;
    }

    throw new Error('Error downloading file');
  }
};

export default downloadFile;
